import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';

interface DropBoxProps {
  applyDropBoxTopSpacing?: number;
}

const DropFileDiv = styled.div<DropBoxProps>`
  position: absolute;
  margin-top: -10px;
  width: 100%;
  min-height: 96px;
  background: var(--background-secondary);
  z-index: 111;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  border: 1px dashed var(--border-secondary);
  border-radius: var(--border-radius-8);
  top: 8px;
  span {
    ${Typography.body_md_medium}
    color: var(--text-primary);
  }

  ${({ applyDropBoxTopSpacing }) =>
    applyDropBoxTopSpacing &&
    css`
      top: ${applyDropBoxTopSpacing}px;
    `}
`;

export { DropFileDiv };
